import { NO, UIObject, UIView, YES } from "uicore-ts"


export type SelectableView = UIView & { selected: boolean }


export class CBButtonGroup<T> extends UIObject {
    
    selectedButton?: SelectableView
    readonly buttonsMap: Record<string, SelectableView>
    
    get value() {
        
        this.selectedButton = this.selectedButton ?? this.buttonsMap.allValues.find(
            (button: SelectableView) => button.selected
        )
        
        const result = Object.entries(this.buttonsMap).find(
            ([_valueKey, button]) => button == this.selectedButton
        )?.[0]!
        
        return result
        
    }
    
    set value(value: string) {
        this.buttonsMap.allValues.everyElement.selected = NO
        if (value) {
            this.buttonsMap[value].selected = YES
            this.selectedButton = this.buttonsMap[value]
            // this.selectionDidChange(sender)
        }
    }
    
    
    constructor(buttons: Record<string, SelectableView> | SelectableView[]) {
        
        super()
        
        let buttonsObject: Record<string, SelectableView> = buttons as any
        if (buttons instanceof Array) {
            buttonsObject = Object.fromEntries(buttons.map((button, index) => [index + "", button]))
        }
        this.buttonsMap = buttonsObject
        
        this.buttonsMap.forEach((button: SelectableView, value) => {
            
            button.controlEventTargetAccumulator.EnterDown["PointerUpInside"] = (
                sender: SelectableView,
                event?: Event
            ) => {
                
                if (this.selectedButton == sender) {
                    return
                }
                
                // Select only the correct button
                this.buttonsMap.allValues.everyElement.selected = NO
                sender.selected = YES
                
                this.selectedButton = sender
                
                this.selectionDidChange(sender, value)
                
            }
            
        })
        
    }
    
    
    selectionDidChange(selectedButton: SelectableView, value: string | undefined) {
        
        // Override this
        console.log("Selection changed to ", selectedButton)
        
    }
    
    
}






